import { Deserializable } from '../_common/deserializable';

export class MoRecord implements Deserializable{
    id: string;
    msgId: string;
    country: string;
    telco: string;
    telcoId: string;
    shortCode: string;
    keyword: string;
    operator: string;
    phone: string;
    eventType: string;
    msisdn: string;
    rkey: string;
    clickId: string;
    transactionAtOrigin: string;
    transactionAt: string;
    createdAt: string;
    panOutState: number;
    panOutAt: string;
    panOutMsg: string;
    panOutTimes: number;
    status: string;
    statusMsg: string;
    channel: string;
    reference: string;
    receivedAt: string;

    deserialize(input: any): this {
      return Object.assign(this, input);
    }
}
